import React, { useState } from 'react';
import Modal from './Modal';
import axios from 'axios';
import { toast } from 'react-toastify';
import Form from '../Form/Form';
import InputText from '../Form/Fields/InputText';
import Button from '../Form/Button';
import { faShop } from '@fortawesome/free-solid-svg-icons';
import { API_BASE_URL } from '../../api';

import './CreateProductModal.scss';

// Public on purpose (see PublicController#createPharmacy) — used from the registration page
// when a pharmacist's own pharmacy isn't in the pre-seeded directory yet. The address
// collected here becomes the pharmacy's own record; Register.js's PharmacyAutofill then
// mirrors it into the registering user's own address, same as picking an existing pharmacy.
export default function CreatePharmacyModal({ show, onClose, onSaved, defaultName = '' }) {
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (data) => {
        setLoading(true);
        try {
            const { data: created } = await axios.post(`${API_BASE_URL}/api/v1/createPharmacy`, {
                name: data.name,
                address: data.address || null,
                city: data.city || null,
                postalCode: data.postalCode || null,
                telephone: data.telephone || null,
            });
            toast.success('Pharmacie créée.');
            onSaved(created);
            onClose();
        } catch (err) {
            toast.error(err.response?.data?.message || 'Une erreur est survenue.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            id="createPharmacyModal"
            title="Nouvelle pharmacie"
            show={show}
            onClose={onClose}
            icon={faShop}
            iconBg="#eff6ff"
            iconColor="#2563eb"
            footer={
                <Button
                    isLoading={loading}
                    loadingMessage="Création…"
                    className="btn btn-primary w-100"
                    type="submit"
                    form="createPharmacyForm"
                >
                    Créer la pharmacie
                </Button>
            }
        >
            <Form id="createPharmacyForm" onSubmit={handleSubmit} defaultValues={{ name: defaultName }}>
                <div className="cdm-section">
                    <p className="cdm-section__label">Identité</p>
                    <div>
                        <span className="cdm-field-label">Nom de la pharmacie <span className="text-danger">*</span></span>
                        <InputText name="name" placeholder="Ex : Pharmacie Al Amal" validationRules={{ required: 'Le nom est requis' }} />
                    </div>
                </div>

                <div className="cdm-section" style={{ marginBottom: 0 }}>
                    <p className="cdm-section__label">Adresse</p>
                    <div className="mb-2">
                        <span className="cdm-field-label">Adresse</span>
                        <InputText name="address" placeholder="Ex : 123 Rue Mohammed V" />
                    </div>
                    <div className="cdm-grid-2">
                        <div>
                            <span className="cdm-field-label">Ville</span>
                            <InputText name="city" placeholder="Ex : Berkane" />
                        </div>
                        <div>
                            <span className="cdm-field-label">Code postal</span>
                            <InputText name="postalCode" placeholder="Ex : 63300" />
                        </div>
                    </div>
                    <div className="mt-2">
                        <span className="cdm-field-label">Téléphone</span>
                        <InputText name="telephone" placeholder="05 XX XX XX XX" />
                    </div>
                </div>
            </Form>
        </Modal>
    );
}
